export default __webpack_public_path__ + "static/media/worldwide.bdf98386.png";